import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { openSnackBar } from '../../redux/actions/snackbar.actions';
import { apiErrorHandler } from '../../utils/errorHandler';
import { getApiUrl } from '../../utils/apiUrls';
import i18next from 'i18next';
import { changeLang } from '../../redux/actions/appSettings.actions';
import { stringPurifer, replaceDynamicString } from '../../utils/helperFn';

const allowedIncorrectPassword = 6
const initial_state = {
    email: {
        value: '',
        isRequired: true,
        msg: null
    },
    password: {
        value: '',
        isRequired: true,
        msg: null
    },
    passwordVisible: false,
    validOptions: {
        requiredFields: ['email', 'password'],
        errorFields: [],
    },
};

const LoginForm = ({loginHandler, getLang, showErrorCount, showErrorHandler, isParentLoading}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const getRefId = searchParams.get('refId');

    const [formVal, setFormVal] = useState(initial_state);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(()=>{
        if(!!showErrorCount){
            setFormVal({...formVal, password:{...formVal.password, msg: replaceDynamicString(
                t("incorrect_password_please_again_attempts"),
                [allowedIncorrectPassword - showErrorCount]
            )}})
        }
    },[showErrorCount])

    useEffect(() => {
        if(!!getLang && !!i18next?.isInitialized) {
            setTimeout(() => {
                i18next.changeLanguage(getLang);
                // i18next.reloadResources([getLang]);
                dispatch(changeLang(getLang))
            }, 500)
        }
    }, [i18next]);

    const handleFieldChange = (e, fieldName) => {
        setFormVal({
            ...formVal,
            [fieldName]: {
                ...formVal[fieldName],
                value: e.target.value
            }
        })
    }

    const handlePassVisiblity = (fieldName) => {
        setFormVal({
            ...formVal,
            [fieldName]: !formVal[fieldName]
        })
    }

    const getReqMsg = (fieldName) => {
        if(fieldName === 'email') {
            return t('email_required');
        } else if(fieldName === 'password') {
            return t('password_required');
        } else {
            return t('field_required')
        }
    }


    const handleValidation = () => {
        //Check required fields are filled
        let currentFormVal = formVal;

        formVal.validOptions.requiredFields.forEach(el => {
            if(currentFormVal[el].value === '') {
                currentFormVal[el].msg = getReqMsg(el);
            } else {
                //Email Validation
                if(el === 'email') {
                    // eslint-disable-next-line
                    const regex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
                    currentFormVal.email.msg = !regex.test(currentFormVal.email.value) ? t("valid_email_address") : null;
                    return;         
                }

                currentFormVal[el].msg = null;
            }
        });

        //Check if form is valid
        let isValidFlag = 0;

        currentFormVal.validOptions.requiredFields.forEach((el) => {
            if(currentFormVal[el].msg === null) {
                isValidFlag++;
            }
        });

        if(isValidFlag === currentFormVal.validOptions.requiredFields.length) {
            !isLoading && encProcess();
        } else {
            setFormVal({
                ...formVal,
                ...currentFormVal,
            })
        }

    }

    const handleFormSubmit = (e) => {
        e.preventDefault();
        handleValidation();
    }


    const encProcess = async () => {
        try {
            // navigate(`/account-lock`);
            // return;
            stringPurifer(formVal.email.value)
            stringPurifer(formVal.password.value)
            setIsLoading(true);
            const getKey = await axios.get(getApiUrl('getSk'));
            if(!!getKey.data) {
                setIsLoading(false);
                const JSEncrypt = window.JSEncrypt;

                //RSA Public Key
                const rsaKey = getKey.data.key;
                const passToEncrypt = formVal.password.value;
                const skid = getKey.data.id;

                //generate AES key
                // var secretPhrase = CryptoJS.lib.WordArray.random(16);
                // var salt = CryptoJS.lib.WordArray.random(128 / 8);
                // //aes key 128 bits (16 bytes) long
                // var aesKey = CryptoJS.PBKDF2(secretPhrase.toString(), salt, {
                //     keySize: 128 / 32
                // });

                
                // var aesOptions = { mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7};
                // var aesEncTrans = CryptoJS.AES.encrypt(JSON.stringify(passToEncrypt), aesKey, aesOptions);

                // console.log(`Plain Password: ${JSON.stringify(passToEncrypt)}`);
                // console.log('[Enc Pass] - AES encrypted transaction [Base64]: ' + aesEncTrans.toString());
                // console.log('AES key [hex]: ' + aesEncTrans.key);

                //encrypt AES key with RSA public key
                var rsaEncrypt = new JSEncrypt({default_key_size: 2048});
                rsaEncrypt.setPublicKey(rsaKey);
                var rsaEncryptedAesKey = rsaEncrypt.encrypt(passToEncrypt.toString());
                var encryptedTransaction = { username: formVal.email.value, password: rsaEncryptedAesKey.toString(), skid };               
                loginHandler(encryptedTransaction, 0);

            }

        } catch (error) {
            setIsLoading(false);
            const errObj = apiErrorHandler(error);

            dispatch(openSnackBar({
                msg: t(errObj.statusText),
                type: 'error'
            }))
        }
    }

    return(
        <form className="cm-auth-form cm-login-form" onSubmit={handleFormSubmit}>
            <div className="form-group mb-3">
            <label htmlFor="email" className='pb-2 text-blue-gray-700 cm-xs-txt fw-medium'><Trans i18nKey="login_email_label" /></label>
                <div className="cm-icon-field position-relative">
                    <input type="email" className="form-control text-blue-800 cm-sm-txt fw-medium" id="email" value={formVal.email.value} placeholder={t("login_email_placeholder")} onChange={(e) => handleFieldChange(e, 'email')} />
                    <FontAwesomeIcon icon={regular('circle-question')} className={`form-text text-blue-gray-500 position-absolute cm-mob-icon d-md-none d-lg-none`} onClick={() => handlePassVisiblity('passwordVisible')} />
                </div>
                {formVal.email.msg !== null && <span className='cm-xs-txt text-danger fw-medium pt-2'>{formVal.email.msg}</span>}
            </div>
            <div className="form-group mb-3">
                <label htmlFor="password" className='pb-2 text-blue-gray-700 cm-xs-txt fw-medium'><Trans i18nKey="password" /></label>
                <div className="cm-icon-field position-relative">
                    {formVal.passwordVisible ? <input type={'text'} autocomplete="true" className="form-control text-blue-800 cm-sm-txt fw-medium" id="password" value={formVal.password.value} placeholder={t("password_placeholder")} onChange={(e) => handleFieldChange(e, 'password')} />:<input type={'password'} autocomplete="true" className="form-control text-blue-800 cm-sm-txt fw-medium" id="password" value={formVal.password.value} placeholder={t("password_placeholder")} onChange={(e) => handleFieldChange(e, 'password')} />}
                    <FontAwesomeIcon icon={formVal.passwordVisible ? regular('eye-slash') : regular('eye')}  className={`form-text text-blue-gray-500 position-absolute cm-pass-visiblility-changer`} onClick={() => handlePassVisiblity('passwordVisible')} />
                </div>
                {formVal.password.msg !== null && <span className='cm-xs-txt text-danger fw-medium pt-2'>{formVal.password.msg}</span>}
            </div>
            <p className='my-0 cm-sm-txt'>
                <Link to={`/forgot-password${!!getLang ? `?lang=${getLang}` : ''}${getRefId ? `${getLang ? '&': '?'}refId=${getRefId}`  : '' }`} className="text-blue-500 fw-medium"><Trans i18nKey="forgot_password" /></Link>
            </p>

            <div className="cm-form-btn-group mt-4 pt-2 d-flex align-items-center">
                <button onClick={handleFormSubmit} className={`cm-icon-btn position-relative btn btn-primary cm-sm-txt cm-btn cm-prim-btn d-flex align-items-center ${isLoading || isParentLoading ? 'cm-disable-btn' : ''}`}>
                    <span className="text-white"><Trans i18nKey="login" /></span>
                    <FontAwesomeIcon icon={regular('angle-right')} className="ps-2" />
                </button>
                <Link className="btn btn-primary cm-btn cm-trans-btn ms-3 text-blue-800 cm-sm-txt" to={`/signup${!!getLang ? `?lang=${getLang}` : ''}${getRefId ? `${getLang ? '&': '?'}refId=${getRefId}`  : '' }`}><Trans i18nKey="create_a_new_account" /></Link>
            </div>
            
        </form>
    )

}

export default LoginForm;